import {
  ListEventTimeSlotsRequest,
  ListEventTimeSlotsResponse,
} from '@wix/ambassador-bookings-availability-v2-time-slot/types';
import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';
import { CalendarState } from '../../components/BookingCalendar/controller';
import { listEventTimeSlots as listEventTimeSlotsHttpRequest } from '@wix/ambassador-bookings-availability-v2-time-slot/http';

export const listEventTimeSlots = async (
  listEventTimeSlotsRequest: ListEventTimeSlotsRequest,
  flowAPI: ControllerFlowAPI,
  state: CalendarState,
): Promise<ListEventTimeSlotsResponse> => {
  try {
    // void panoramaQueryAvailabilityInteractionStart({
    //   flowAPI,
    //   state,
    //   request: listEventTimeSlotsRequest,
    // });
    const response = (
      await flowAPI.httpClient.request(
        listEventTimeSlotsHttpRequest(listEventTimeSlotsRequest),
      )
    ).data;

    // void panoramaQueryAvailabilityInteractionEnd({
    //   flowAPI,
    //   response,
    // });

    return response;
  } catch (e) {
    // void panoramaQueryAvailabilityInteractionEnd({
    //   flowAPI,
    //   error: e as string,
    // });
    throw e;
  }
};
